import { aeEmirates, auStates, caProvinces, usStates } from 'boot/countries';
import { DateTime } from 'luxon';

const countrySubdivisions = {
  US: usStates,
  AU: auStates,
  AE: aeEmirates,
  CA: caProvinces,
};

export const getCountrySubdivisions = (country) => countrySubdivisions[country] || [];

const normalizeZoneName = (text) => text.toLowerCase().replace(/_/g, ' ');

/**
 * IANA zone ids spell a multi-word city with an underscore (`America/New_York`), which nobody types.
 * Both sides are normalized so a space and an underscore are the same character to search with.
 *
 * @param {string} [search] - what the user typed
 * @returns {string[]} matching IANA zone ids
 */
export const searchTimeZones = (search) => {
  const needle = normalizeZoneName(search ?? '').trim();

  return Intl.supportedValuesOf('timeZone')
    .filter((zone) => normalizeZoneName(zone).includes(needle));
};

/**
 * The zone as the app spells it everywhere: its current abbreviation and its city, e.g. `EDT - New
 * York`. The region prefix is dropped and the IANA underscore reads as the space it stands for.
 *
 * @param {string} timeZone - an IANA zone id
 * @returns {string} the label to show
 */
export const formatTimeZoneLabel = (timeZone) => {
  const abbreviation = DateTime.now().setZone(timeZone).toFormat('ZZZZ');
  const city = timeZone.split('/').pop().replace(/_/g, ' ');

  return `${abbreviation} - ${city}`;
};
